// extracted by mini-css-extract-plugin
export default {"external":"aFuZN0","deprecatedBorderRadius":"bFuZN0","hasAnimation":"cFuZN0","container":"dFuZN0"};